import React from 'react';
import Breadcrumbs from '~/components/Breadcrumbs/Breadcrumbs';
import Spacer from '~/components/Spacer/Spacer';
import Spinner from '~/components/Spinner/Spinner';
import ToggleSwitch from '~/components/ToggleSwitch/ToggleSwitch';
import useGlobalKeys from '~/hooks/globalKeys/useGlobalKeys';
import classes from './GlobalKeysManagement.module.css';

const GlobalKeysManagement: React.FC = () => {
  const { globalKeys, loadingConfig, toggleKeyFlag, refreshGlobalKeys } = useGlobalKeys();

  const formatKeyName = (key: string): string => {
    return key
      .split('_')
      .map(word => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase())
      .join(' ');
  };

  if (loadingConfig.flag) {
    return (
      <div className={classes.loadingContainer}>
        <Spinner />
        <h3 style={{ textAlign: 'center' }}>{loadingConfig.comment}</h3>
      </div>
    );
  }

  return (
    <div className='content-container'>
      <Breadcrumbs />
      <Spacer height={20} />
      
      <div className={classes.header}>
        <h1>Global Keys Management</h1>
        <button 
          className='btn-primary btn-standard bold'
          onClick={refreshGlobalKeys}
          disabled={loadingConfig.flag}
        >
          Refresh
        </button>
      </div>
      
      <Spacer height={20} />

      {globalKeys.length === 0 ? (
        <div className={classes.noDataContainer}>
          <p className='default-text'>No global keys found</p>
        </div>
      ) : (
        <div className={classes.cardsGrid}>
          {globalKeys.map((globalKey) => (
            <div key={globalKey.uuid} className={`${classes.keyCard} ${globalKey.flag ? classes.enabled : ''}`}>
              <div className={classes.cardContent}>
                <div className={classes.keyInfo}>
                  <h3 className={classes.keyTitle}>{formatKeyName(globalKey.key)}</h3>
                </div>
                
                <div className={classes.toggleSection}>
                  <div className={classes.statusSection}>
                    <span className={`${classes.statusText} ${
                      globalKey.flag ? classes.statusEnabled : classes.statusDisabled
                    }`}>
                      {globalKey.flag ? 'Enabled' : 'Disabled'}
                    </span>
                  </div>
                  <ToggleSwitch
                    checked={globalKey.flag}
                    onChange={() => toggleKeyFlag(globalKey.uuid, globalKey.flag)}
                    disabled={loadingConfig.flag}
                  />
                </div>
              </div>
            </div>
          ))}
        </div>
      )}
    </div>
  );
};

export default GlobalKeysManagement; 